import React, { Component } from 'react'
import { observer } from 'mobx-react'

import InvoiceDetails from './invoicedetails'

@observer(['invoices'])
export default class EditInvoice extends Component {
  constructor(props) {
    super(props)

  }

  loadInvoice(invoiceId, qbItemList, qbTermsList, qbTaxRatesList, callback) {
    this.props.invoices.loadInvoiceNoQB(invoiceId, qbItemList, qbTermsList, qbTaxRatesList, (invoice) => {
      if (invoice.closeDate != null) {
        let rawDate = new Date(invoice.closeDate)
        invoice.closeDate = rawDate.yyyymmdd()
      }

      if (callback) {
        callback(invoice)
      }
      
    })
  }

  loadInvoiceItems(invoiceId, qbItemList, callback) {
    this.props.invoices.loadInvoiceHardware(invoiceId, qbItemList, (hardware) => {
      if (callback) {
        callback(hardware)
      }
    })
  }

  updateInvoice(invoiceInfo, callback) {
    this.props.invoices.updateInvoice(invoiceInfo, (invoice) => {
      if (callback != null) {
        callback(invoice)
      }
    })
  }

  render() {
    return (
      <div>
        <InvoiceDetails type={ 'edit' } invoiceId={ this.props.params.invoiceId } companyId={ this.props.params.companyId } loadInvoice={ this.loadInvoice.bind(this) } loadInvoiceItems={ this.loadInvoiceItems.bind(this) } updateInvoice={ this.updateInvoice.bind(this) } />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/company/editinvoice.js